import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import CompanyGroupEditor from "../../editors/customer/companyGroup";

const CompanyGroups: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.CompanyGroupsList}
			endpoint={Endpoint.CompanyGroups}
			addScreen={{ screen: CompanyGroupEditor, isAllowed: hasPermission(Permission.CompanyGroupsAdd) }}
			editScreen={{ screen: CompanyGroupEditor, isAllowed: hasPermission(Permission.CompanyGroupsUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.CompanyGroupsDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default CompanyGroups;
